import React, {useState, useRef} from 'react';

import celibataireW from '../../../../assets//images/svg/001-W-celibataire.svg';
import unionsW from '../../../../assets/images/svg/001-W-unions.svg';
import divorceeW from '../../../../assets/images/svg/001-W-divorcee.svg';
import veuveW from '../../../../assets/images/svg/001-W-veuve.svg';


import celibataireM from '../../../../assets/images/svg/001-M-celibataire.svg';
import unionsM from '../../../../assets/images/svg/001-M-unions.svg';
import divorceeM from '../../../../assets/images/svg/001-M-divorcee.svg';
import veuveM from '../../../../assets/images/svg/001-M-veuve.svg';


import {RegexFields} from '../../../../constants/utils/regexFields';
import {DateWithModal} from '../../../../_common/dateWithModal';
import countryTranslation from 'i18n-iso-countries';
import french from 'i18n-iso-countries/langs/fr.json';
import { DepartamentsList } from '../../../../_common/personal/departamentsList';

export const FamilySituationForm = ({ personalData, setPersonalData, formReference }) => {
	const filledRef = useRef(null);
	countryTranslation.registerLocale(french);
	let personalDataGender = parseInt(personalData.gender) || personalData.gender === "Male" ? 2 : 1;
	const gender = ["", "Female", "Male", "Other"];

	const familyStatusText = [
		{},
		{ Male: { label: "Célibataire", logo: celibataireM }, Female: { label: "Célibataire", logo: celibataireW } },
		{ Male: { label: "Marié", logo: unionsM }, Female: { label: "Mariée", logo: unionsW } },
		{ Male: { label: "Divorcé", logo: divorceeM }, Female: { label: "Divorcée", logo: divorceeW } },
		{ Male: { label: "Veuf", logo: veuveM }, Female: { label: "Veuve", logo: veuveW } },
		{ Male: { label: "Union Libre", logo: unionsM }, Female: { label: "Union Libre", logo: unionsW } },
		{ Male: { label: "Pacsé", logo: unionsM }, Female: { label: "Pacsée", logo: unionsW } },
	];

	return (
		<section className="block mt-2 pt-2">
			<h4 className="h4 text-uppercase text-secondary font-weight-bolder mt-2 mb-1">SITUATION FAMILIALE *</h4>
			<form className="py-sm" noValidate ref={formReference} id="FamilySituationForm">
				<div className="form-row">
					<div
						className={"form-group col col-lg-4 col-xl-2"}
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 1 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 1 || personalData.civilStatus === "Single" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[1][gender[personalDataGender]].logo} alt="Célibataire" />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[1][gender[personalDataGender]].label}</h2>
						</div>
					</div>
					<div
						className="form-group col col-lg-4 col-xl"
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 2 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 2 || personalData.civilStatus === "Married" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[2][gender[personalDataGender]].logo} alt={familyStatusText[2][gender[personalDataGender]].label} />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[2][gender[personalDataGender]].label}</h2>
						</div>
					</div>
					<div
						className="form-group col col-lg-4 col-xl"
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 3 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 3 || personalData.civilStatus === "Divorced" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[3][gender[personalDataGender]].logo} alt={familyStatusText[3][gender[personalDataGender]].label} />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[3][gender[personalDataGender]].label}</h2>
						</div>
					</div>
					<div
						className="form-group col col-lg-4 col-xl"
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 4 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 4 || personalData.civilStatus === "Widowed" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[4][gender[personalDataGender]].logo} alt={familyStatusText[4][gender[personalDataGender]].label} />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[4][gender[personalDataGender]].label}</h2>
						</div>
					</div>
					<div
						className="form-group col col-lg-4 col-xl"
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 5 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 5 || personalData.civilStatus === "FreeUnion" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[5][gender[personalDataGender]].logo} alt={familyStatusText[5][gender[personalDataGender]].label} />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[5][gender[personalDataGender]].label}</h2>
						</div>
					</div>
					<div
						className="form-group col col-lg-4 col-xl"
						onClick={() => {
							setPersonalData({ ...personalData, civilStatus: 6 });
						}}>
						<div className={"card card-body text-center picker-card" + (personalData.civilStatus === 6 || personalData.civilStatus === "CivilUnion" ? " active" : "")}>
							<img className="img-fluid mx-auto my-3 mb-2 h-6" src={familyStatusText[6][gender[personalDataGender]].logo} alt={familyStatusText[6][gender[personalDataGender]].label} />
							<h2 className="h6 font-weight-bolder my-auto">{familyStatusText[6][gender[personalDataGender]].label}</h2>
						</div>
					</div>
				</div>
				<input type="text" id="familyStatusFilled" className="d-none" />
				<div className={"invalid-feedback alert-danger alert"}>Veuillez choisir une option</div>
			</form>
		</section>
	);
};